import { useQuery } from "@tanstack/react-query";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import {
  DiscoveredSkillsResponse,
  fetchDiscoveredSkills
} from "PFCore/services/skills/fetch_discovered_skills";
import { QueryOptions } from "PFTypes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { skillsKeys } from "./query_keys";

export const useDiscoveredSkills = (options?: QueryOptions<DiscoveredSkillsResponse>) => {
  const { showGrowl } = useGrowlStoreActions();
  const { t } = useTranslation("profiles", { keyPrefix: "show.parts" });

  const { isError, ...query } = useQuery({
    queryKey: skillsKeys.discovered(),
    queryFn: () => fetchDiscoveredSkills(),
    ...options
  });

  useEffect(() => {
    if (!isError) {
      return;
    }

    showGrowl({
      message: t("skillsModal.errors.fetchDiscoveredSkills"),
      kind: "error"
    });
  }, [showGrowl, isError, t]);

  return query;
};
